import React from "react";
import PredictionPage from "../../components/PredictionPage";

function GOLD() {
  return (
    <PredictionPage
      title="GOLD"
      content="This is the GOLD AI Trading Predictions page."
      canonical="/metals/gold-ai-trading-predictions"
      categoryKey="nav.metals"
      categoryPath="/metals"
      symbol="GOLD"
    />
  );
}

export default GOLD;
